<template lang="pug">
  app-dialog(v-model="$_show" header="Создать заявку на оплату" width="756")
    .advocatapp
        v-form(ref="addAppItemForm" v-model="valid")
          app-date-picker(v-model="form.eventDate" label="Дата мероприятия" :viewFormat="'DD.MM.YYYY'" :rules="[rules.required]")
          app-select(v-if="isAdvocatEventTypesLoaded" v-model="form.advocatEventType" :items="advocatEventTypes" label="Тип мероприятия" item-text="title" :rules="[rules.required]")
          app-combobox(v-if="isBoostingKfsLoaded"  v-model="form.boostingKfs" :items="boostingKfs" item-text="title" label="Коэффициенты" )
          app-text-field(v-model="form.tariff" label="Тариф" :rules="[rules.required, rules.number]")
          
    .sud-dialog-card__footer(slote="footer")
      v-layout.justify-space-between
         v-btn.text-none(
           v-if="canDelete"
           dark
           color="#ED0E51" 
           large depressed 
           @click="deleteAdvocatAppItem") Удалить
         v-btn.text-none(
           :disabled="isNotReady" 
           :dark="isNotReady == false"
           color="#1B93AD" 
           large depressed 
           @click="createAdvocatAppItem") {{confirmText}}

</template>

<script>
import moment from 'moment'
import { AppDialogToggable } from '@/components'
import { $_validate_rules } from '@/common/ValidateRules'


import { mapGetters } from 'vuex';

export default {
  mixins: [AppDialogToggable, $_validate_rules],
  props: {
    appItem: null,
  },
  data () {
    const defaultForm = Object.freeze({
      id: null,
      eventDate: moment().format('YYYY-MM-DD'),
      advocatEventType: '',
      boostingKfs: [],
      tariff: ''
    })

    return {
      valid: false,
      form: Object.assign({}, defaultForm),
      defaultForm
    }
  },
  methods: {
    deleteAdvocatAppItem() {
      if(this.canDelete) {
         this.$store.dispatch('advocat/DELETE_APP_ITEM', { appItemId: this.appItem.id })
         .then(() => this.$emit('edited'))
         .catch(() => this.$emit('error'))
      } else {
         this.$emit('error')
      }
    },
    createAdvocatAppItem() {
      if (this.$refs.addAppItemForm.validate()) {
          this.form.eventDate=moment(this.form.eventDate).format('YYYY-MM-DD HH:mm')
          if(this.form.id==null)
              this.$store.dispatch('advocat/CREATE_APP_ITEM', this.form)
          else if(this.appItem!=null && this.appItem.appStatus.name === "NEW")
              this.$store.dispatch('advocat/UPDATE_APP_ITEM', this.form)
          this.$emit('edited')
      }
    },
  },
  watch: {
    $_show (value) {
      if (value) {
        let baseObj = this.appItem || this.defaultForm
        this.form = JSON.parse(JSON.stringify(baseObj))
      }
    },
  },
  computed: {
    ...mapGetters('advocat', ['advocatEventTypes','isAdvocatEventTypesLoaded','boostingKfs','isBoostingKfsLoaded']),
    isNotReady () {
      if(!this.valid) return true
      return false
    },
    isReject () {
      return this.appItem!=null && this.appItem.appStatus.name === "REJECT"
    },
    canDelete () {
      return this.appItem!=null && (this.appItem.appStatus.name === "NEW" || this.appItem.appStatus.name === "REJECT")
    },
    confirmText() {
      if(this.appItem!=null && this.appItem.appStatus.name === "REJECT") return "Принять"
      return this.appItem!=null ? "Редактировать" : "Создать"
    },
  },
}
</script>

<style lang="scss" scoped>

</style>

